(() => {
  const toggle = document.getElementById('ps-menu-toggle');
  const menu = document.getElementById('ps-mobile-menu');
  const overlay = document.getElementById('ps-menu-overlay');
  const header = document.querySelector('[data-ps-header]');
  const isDesktop = () => window.innerWidth > 780;

  // --ps-ann-height: fixed announcement bar above the header; --ps-header-height: total fixed stack (bar + header)
  const setHeaderHeight = () => {
    if (!header) return;
    const ann = document.querySelector('.ps-announcement-section');
    const annH = ann ? ann.offsetHeight : 0;
    document.documentElement.style.setProperty('--ps-ann-height', `${annH}px`);
    document.documentElement.style.setProperty('--ps-header-height', `${annH + header.offsetHeight}px`);
  };
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight, { passive: true });

  /* ---------- Desktop dropdowns: mega panels + simple link dropdowns (any number of menu items) ---------- */
  const dropdowns = [...document.querySelectorAll('[data-ps-dropdown]')].map((wrap) => ({
    wrap,
    trigger: wrap.querySelector('[data-ps-dropdown-trigger]'),
    panel: wrap.querySelector('[data-ps-dropdown-panel]'),
    timer: null,
  })).filter((d) => d.trigger && d.panel);

  const closeDropdown = (d) => {
    d.wrap.classList.remove('is-open');
    d.trigger.setAttribute('aria-expanded', 'false');
    d.panel.setAttribute('aria-hidden', 'true');
  };
  const closeAll = (except) => dropdowns.forEach((d) => { if (d !== except) closeDropdown(d); });
  const openDropdown = (d) => {
    setHeaderHeight();
    closeAll(d);
    d.wrap.classList.add('is-open');
    d.trigger.setAttribute('aria-expanded', 'true');
    d.panel.setAttribute('aria-hidden', 'false');
  };

  const canHover = window.matchMedia('(hover: hover)').matches;

  dropdowns.forEach((d) => {
    // Trigger is a link to the item's page (e.g. Shop). Mouse: hover opens, click navigates.
    // Touch: first tap opens the dropdown, second tap navigates. A "#" link only toggles.
    d.trigger.addEventListener('click', (e) => {
      const href = d.trigger.getAttribute('href') || '';
      const isLink = href !== '' && href !== '#' && !href.endsWith('/#');
      if (isLink && (canHover || d.wrap.classList.contains('is-open'))) return;
      e.preventDefault();
      if (d.wrap.classList.contains('is-open')) closeDropdown(d);
      else openDropdown(d);
    });
    // Keyboard: arrow down (or space) opens the dropdown; Enter follows the link
    d.trigger.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' || e.key === ' ') {
        e.preventDefault();
        openDropdown(d);
        d.panel.querySelector('a')?.focus();
      } else if (e.key === 'Escape') {
        closeDropdown(d);
      }
    });
    d.wrap.addEventListener('focusout', (e) => { if (!d.wrap.contains(e.relatedTarget)) closeDropdown(d); });
    if (canHover) {
      const scheduleClose = () => { clearTimeout(d.timer); d.timer = setTimeout(() => closeDropdown(d), 140); };
      d.wrap.addEventListener('mouseenter', () => { if (isDesktop()) { clearTimeout(d.timer); openDropdown(d); } });
      d.wrap.addEventListener('mouseleave', () => { if (isDesktop()) scheduleClose(); });
    }
    d.panel.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => closeDropdown(d)));
  });

  document.addEventListener('click', (e) => {
    dropdowns.forEach((d) => { if (!d.wrap.contains(e.target)) closeDropdown(d); });
  });

  /* ---------- Mobile menu ---------- */
  const subs = [...document.querySelectorAll('[data-ps-mobile-sub]')].map((wrap) => ({
    trigger: wrap.querySelector('[data-ps-mobile-sub-trigger]'),
    panel: wrap.querySelector('.ps-mobile-shop__panel'),
    back: wrap.querySelector('[data-ps-mobile-sub-back]'),
  })).filter((s) => s.trigger && s.panel);

  // Sub-panels slide over the menu; "← Title" returns to the main list
  const setSub = (s, open) => {
    s.trigger.setAttribute('aria-expanded', String(open));
    if (open) {
      s.panel.hidden = false;
      requestAnimationFrame(() => s.panel.classList.add('is-open'));
      s.back?.focus();
    } else {
      s.panel.classList.remove('is-open');
      setTimeout(() => { if (!s.panel.classList.contains('is-open')) s.panel.hidden = true; }, 240);
    }
  };
  subs.forEach((s) => {
    s.trigger.addEventListener('click', () => setSub(s, true));
    s.back?.addEventListener('click', () => { setSub(s, false); s.trigger.focus(); });
  });

  const setMenu = (open) => {
    if (!toggle || !menu || !overlay) return;
    document.body.classList.toggle('menu-open', open);
    document.body.classList.toggle('ps-menu-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    menu.setAttribute('aria-hidden', String(!open));
    overlay.setAttribute('aria-hidden', String(!open));
    if (open) closeAll();
    else subs.forEach((s) => setSub(s, false)); // always reopen on the main list
  };

  if (toggle && menu && overlay) {
    toggle.addEventListener('click', () => setMenu(toggle.getAttribute('aria-expanded') !== 'true'));
    overlay.addEventListener('click', () => setMenu(false));
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));
    window.addEventListener('resize', () => { if (isDesktop()) setMenu(false); }, { passive: true });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeAll();
    setMenu(false);
  });
})();
